import {useEffect, useState} from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import {useLocation} from 'react-router-dom'
import {PageTitle} from 'src/_metronic/layout/core'
import {useAuth2} from '../modules/authv2/Auth2Provider'
import {fetchMenuActionsByRole, fetchSubMenuByUrl} from '../services/menu'

interface Props {
  breadcrumbs: {title: string; path: string; isSeparator: boolean; isActive: boolean}[]
  fallbackTitle: string
}

export const BasicBreadcrumbs: React.FC<Props> = ({breadcrumbs, fallbackTitle}) => {
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState(fallbackTitle)
  const {selectedRole} = useAuth2()
  const location = useLocation()

  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true)
      try {
        const response = await fetchMenuActionsByRole(selectedRole)
        if (response.success) {
          const currentPath = location.pathname
          const subMenuResponse = await fetchSubMenuByUrl(currentPath)
          if (subMenuResponse.success) {
            setTitle(subMenuResponse?.data?.titulo ?? fallbackTitle)
          }
        }
      } catch (error) {
        console.error('Error fetching menu actions by role', error)
      } finally {
        setLoading(false)
      }
    }

    fetchPermissions()
  }, [selectedRole])

  return <PageTitle breadcrumbs={breadcrumbs}>{loading ? '...' : title}</PageTitle>
}
